import React, { useState, useEffect, useRef } from 'react';
import { Button } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import "../../index.css";
import './style.css';

const EditableTextField = ({ text, onSave, placeholder, selectedCard, renderAttachments, listArchives, setAttachments, saveDescription, fetchLogs }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(text);
    const quillRef = useRef(null);

    useEffect(() => {
        const quillEditor = quillRef.current?.getEditor();
        if (quillEditor) {
            const handlePaste = (event) => {
                event.stopPropagation();
            };
            quillEditor.root.addEventListener('paste', handlePaste);

            return () => {
                quillEditor.root.removeEventListener('paste', handlePaste);
            };
        }
    }, []);

    const handleSave = () => {
        // Enviar o valor original do Quill com tags HTML
        saveDescription(value);
        onSave(value);
        setIsEditing(false);
    };

    const handleCancelComment = () => {
        setIsEditing(false);
        setValue(text); // Reverter para o valor original ao cancelar
    };

    const convertUrlsToLinks = (text) => {
        const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
        return text.replace(urlPattern, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`);
    };

    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
        ],
    };

    const convertNewlinesToBr = (text) => text.replace(/\n/g, '<br/>');

    return (
        <div>
            {isEditing ? (
                <div>
                    <ReactQuill
                        ref={quillRef}
                        value={convertNewlinesToBr(value)}
                        onChange={setValue}
                        modules={modules}
                        placeholder={placeholder}
                        style={{ minWidth: "24vw", height: 'auto', marginTop: '15px' }}
                        className='reactquill-descricao textfield-comments'
                    />
                    <br></br>
                    <div style={{ marginBottom: '2vh' }}>
                        <Button onClick={handleSave} className='comment-button'>
                            Salvar
                        </Button>
                        <Button onClick={handleCancelComment} className='comment-cancel'>
                            Cancelar
                        </Button>
                    </div>
                </div>
            ) : (
                <div style={{ position: 'relative' }}>
                    <div
                        className='description-div'
                        style={{
                            marginBottom: '30px',
                            maxWidth: '25vw',
                            minWidth: '28vw',
                            maxHeight: '20vw',
                            overflowY: 'auto',
                            wordBreak: 'break-word',
                            whiteSpace: 'pre-wrap',
                            display: 'block',
                            fontSize: '15px',
                        }}
                        dangerouslySetInnerHTML={{ __html: convertUrlsToLinks(text || placeholder) }}
                    />
                    <div style={{ position: 'absolute', top: -40, right: 0 }}>
                        <Button onClick={() => setIsEditing(true)} className='description-edit'>
                            Editar
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EditableTextField;
